import { Component, OnInit, OnDestroy, Input,AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { FileService } from "../../../_services/file.service";
import { PriorInfoService } from '../../../_services/index';
import { FutureInfoService, CountryService, StateService } from '../../../_services/index';
import { Http } from "@angular/http";
import { ViewEncapsulation } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatDialog } from '@angular/material';
import { DialogPdfComponent } from '../dialog-pdf/dialog.component';
import { AuthenticationService } from '../../../_services/index';

@Component({
  selector: 'app-prior-higher-education',
  templateUrl: './prior-higher-education.component.html',
  styleUrls: ['./prior-higher-education.component.css'],
  providers:[FileService,PriorInfoService,FutureInfoService]
})
export class PriorHigherEducationComponent implements OnInit, OnDestroy {

  public validYear = [/[1-9]/, /\d/, /\d/, /\d/]
  date: any[] = [ /\d/, /\d/,'-', /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];
  monthyear: any[] = [ /[0-2]/, /[1-9]/,'-', /\d/, /\d/, /\d/, /\d/];

  priorForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  fileuploadSub: Subscription;
  postSecondarySub: Subscription;
  
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  hideHowManyYears:boolean;
  isRequired:boolean;
  public personalEmail: string;
  currentUser:any;
  loading:boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  public filename;
  public filepath;
  postSecondaryData :any;
  maskpattern = false;
  highschoolId;
  pdf: any;
  pdfSrc: string = '';
  isCNIC = false;
  showDegreeDate = false;
  mailStates = [];

  constructor(private _fb: FormBuilder,
    private router: Router,
    private _fileService:FileService,
    public api: PriorInfoService,
    public api2: FutureInfoService,
    public dialog: MatDialog,
    public stateApi: StateService,
    private loginservice: AuthenticationService,
    ) { }

    ngOnInit() {

        this.createForm();
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.personalEmail=this.currentUser?this.currentUser.email:'';
        this.priorForm.get('personalEmail').setValue(this.personalEmail);
        this.getPriorInfo();
        //this.postSecondarysList();
        this.hideHowManyYears = true;
        window.scrollTo(300, 500)
        this.getMailStateList();
        this.checkCinc();
        
    }

    ngAfterViewInit() {
        
        var element1 = document.querySelector('.droppable1');
        this.makeDroppable(element1, this.callback,this);
    
        var element2 = document.querySelector('.droppable2');
        this.makeDroppable(element2, this.callback,this);
    }

    ngOnDestroy() {
        
        if (this.formChangeSub) {
            this.formChangeSub.unsubscribe();
        }
        if (this.getdataSub)  {
            this.getdataSub.unsubscribe();
        }
        if (this.submitdataSub)  {
            this.submitdataSub.unsubscribe();
        }
        if (this.fileuploadSub)  {
            this.fileuploadSub.unsubscribe();
        }

    }

    createForm()  {

        this.priorForm  = this._fb.group({
        
            isCompletedCollege: [''],
            howManyClg: [''],
            recentClg: [''],
            // recentGpa: ['',[Validators.min(0),Validators.max(5),Validators.pattern(/^[0-5]\d*$/)]],
            recentGpa: [''],
            recentYear: [''],
            graduateYear: [''],
            personalEmail: [''],
            fileId: [''],
            educationLevel:[''],
            degreeDate:[''],
            coluniCountry:['US'],
            coluniState:[''],
            coluniCity:[''],
            attBegan:[''],
            attEnd:[''],
            expulsionprocedures:['']
        });

        this.formChangeSub = this.priorForm.valueChanges.subscribe(data => this._onValueChanged());
        
        this._onValueChanged();

    }

    onSubmit()  {
        
        let recentClgVal = this.priorForm.controls.recentClg.value;
    
        let recentClg;
        
        console.log(this.priorForm.controls.expulsionprocedures.value);

        if(typeof recentClgVal === 'object')
        {
            recentClg = this.priorForm.controls.recentClg.value.id;
        }
        else
        {
            recentClg = this.highschoolId;

        }

        const body = JSON.stringify({
        
            isCompletedCollege: this.priorForm.controls.isCompletedCollege.value,
            howManyClg: this.priorForm.controls.howManyClg.value,
            recentClg: recentClg,
            recentGpa:this.priorForm.controls.recentGpa.value,
            recentYear:this.priorForm.controls.recentYear.value,
            graduateYear:this.priorForm.controls.graduateYear.value,
            personalEmail:this.priorForm.controls.personalEmail.value,
            fileId:this.priorForm.controls.fileId.value,
            educationLevel:this.priorForm.controls.educationLevel.value,
            degreeDate:this.priorForm.controls.degreeDate.value,
            coluniCountry:'US',
            coluniState:this.priorForm.controls.coluniState.value,
            coluniCity:this.priorForm.controls.coluniCity.value,
            attBegan:this.priorForm.controls.attBegan.value,
            attEnd:this.priorForm.controls.attEnd.value,
            expulsionprocedures:this.priorForm.controls.expulsionprocedures.value
        
        });
        //console.log(body);
        this.submitting = true;
        this.api.postPriorInfo$(body)
        .subscribe(
            data => {
            this.error = false;
            this.submitting = false;
            const response = data;
                this.errorFlag = false;
                this.successMessage = response.message;
                if(!this.canDeactivateCheck)
                {
                    this.checkingSubmit = true;
                    
                    this.router.navigate(['/profile/future-college-plans']);
                }
            },
            error => {
                this.submitting = false;
                this.errorFlag = true;
                const errordata = JSON.parse(error._body);
                if (errordata.success === 0) {
                    this.errorMessage = errordata.message;
                    this.errorFlag = true;
                    this.fieldErrors = errordata.errors;
                }
            },
        );
    }

    private _onValueChanged() {
        
        if(this.checkChange)
        {
            //console.log('prior');
            this.valueChange = true

        }
            
    }

    makeDroppable(element, callback,classObj) {
        
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        //input.setAttribute('multiple', 'true');
        input.style.display = 'none';

        input.addEventListener('change', function (e) {
            triggerCallback(e, classObj);
        });

        element.appendChild(input);

        element.addEventListener('dragover', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.add('dragover');
        });

        element.addEventListener('dragleave', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
        });

        element.addEventListener('drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
            triggerCallback(e,classObj);
        });

        element.addEventListener('click', function() {
            input.value = null;
            input.click();
        });

        function triggerCallback(e,obj) {
            var files;
            if(e.dataTransfer) {
                files = e.dataTransfer.files;
            } else if(e.target) {
                files = e.target.files;
            }
            callback.call(null, files,e,obj);
        }
    }
    
    
    callback(files, event, classobject?: any) {
        
        classobject.loading = true;
        for (let i = 0; i < files.length; i++) {
            let ext = '';
            //console.log(files[i]);
            // Here, we simply log the Array of files to the console.
            let mimeType = files[i].type;
            ext = files[i].name.split('.').pop();
            //console.log(ext);
            const allowedMIMEType = ['application/pdf'];
            if(allowedMIMEType.indexOf(mimeType)>= 0 ){
                if((allowedMIMEType.indexOf(mimeType) == 0) || (allowedMIMEType.indexOf(mimeType) == 1) ){

                    classobject.filetype = ext;

                }else{
                    classobject.filetype = ext;

                }
                //console.log(classobject.quoteId);
                const body = {
                    attachableId: '',
                    file: files[i],
                    attachableType:'Prior'
                };

                //console.log(body);
                
                    classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(

                    responsedata => {

                    //console.log(responsedata);

                        let fileId = JSON.parse(responsedata._body).data.fileId;
                        //console.log(fileId);
                        classobject.priorForm.controls["fileId"].setValue(fileId);
                        classobject.loading = false;
                        classobject.filename = files[i].name;
                            
                        let filelink = JSON.parse(responsedata._body).data.filelink;
                        classobject.filepath = filelink;
                    },
                    error => {

                        classobject.loading = false;
                    });

            }else{

                alert("File not allowed");
                classobject.loading = false;
            }
        }
        //console.log(classobject.uploadFilenames);

    }

    changeCompleteClg() {

        let isCompletedCollege = this.priorForm.controls.isCompletedCollege.value;
        /* console.log(isCompletedCollege);
        console.log(this.priorForm); */
        if(isCompletedCollege == 1)
        {

            this.hideHowManyYears = false;
            this.isRequired = true;
            this.maskpattern = true;
        }
        else if(isCompletedCollege ==  '')
        {
            
            this.hideHowManyYears = true;
            this.isRequired = true;
            this.maskpattern = false;
            this.priorForm.controls['howManyClg'].setValue('');
            this.priorForm.controls['recentGpa'].setValue('');
            this.priorForm.controls['graduateYear'].setValue('');
            this.priorForm.controls['recentYear'].setValue('');
            this.priorForm.controls['recentClg'].setValue('');
                
        }
        else
        {

            this.maskpattern = false;
            this.hideHowManyYears = true;
            this.isRequired = false;

        }
        console.log(this.priorForm);
    }

    getPriorInfo() {

        this.loading = true;
        const body = JSON.stringify({
            email: this.personalEmail
        });

        this.getdataSub = this.api.getPriorInfo(body)
        
        .subscribe(responsedata => {
            //console.log(responsedata.data);
            let priorInfodata = responsedata.data;
            console.log(priorInfodata);
            
            //console.log(JSON.parse(academicInfodata.carrer_sectors.json()));
            if(priorInfodata.is_completed_college)
            {
                this.priorForm.controls['isCompletedCollege'].setValue(priorInfodata.is_completed_college);
                
            }
            
            this.priorForm.controls['howManyClg'].setValue(priorInfodata.how_many_clg==0?'':priorInfodata.how_many_clg);
            this.priorForm.controls['recentGpa'].setValue(priorInfodata.recent_gpa==0?'':priorInfodata.recent_gpa);
            this.priorForm.controls['graduateYear'].setValue(priorInfodata.graduate_year);
            this.priorForm.controls['recentYear'].setValue(priorInfodata.recent_year);
            this.changeCompleteClg();
            this.filename = priorInfodata.orig_name;
            this.filepath = priorInfodata.full_path;

            if(priorInfodata.educationLevel){

                this.priorForm.controls['educationLevel'].setValue(priorInfodata.educationLevel);
                
                this.priorForm.controls['degreeDate'].setValue(priorInfodata.degreeDate);
                this.priorForm.controls['coluniCountry'].setValue(priorInfodata.coluniCountry);
                this.priorForm.controls['coluniState'].setValue(priorInfodata.coluniState);
                this.priorForm.controls['coluniCity'].setValue(priorInfodata.coluniCity);
                this.priorForm.controls['attBegan'].setValue(priorInfodata.attBegan);
                this.priorForm.controls['attEnd'].setValue(priorInfodata.attEnd);
                if(priorInfodata.expulsionprocedures){
                    this.priorForm.controls['expulsionprocedures'].setValue(priorInfodata.expulsionprocedures);

                }
                this.oneducationLevelChange(priorInfodata.educationLevel);

            }
            
            
            this.highschoolId = JSON.parse(priorInfodata.recent_clg_id).id;
            this.priorForm.controls['recentClg'].setValue(JSON.parse(priorInfodata.recent_clg_id).name);
            
            setTimeout(()=>{
               
                this.checkChange = true;
                this.loading = false;
                
            },2000);

                        
        });
    }

    canDeactivate() {

        if(this.valueChange  && this.checkingSubmit == false)
        {
            if(confirm("Want to save changes?")) {

                this.canDeactivateCheck = true;
                this.onSubmit();

            }
        }
        
        return true;
    }

    renderHero = (data: any) : SafeHtml => {
        //console.log(data);
        let html = `<span>${data.name}</span>`;
        return html;
    };  

    changePdf(url){

        this.pdfSrc = url;
        //console.log(this.pdfSrc);
        this.openDialog();
      }
    
    openDialog() {
        const dialogRef = this.dialog.open(DialogPdfComponent, {
            height: '600px',
            data: { url: this.pdfSrc }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });
    }

    oneducationLevelChange(data){
        console.log(this.priorForm);
        if(data == 'Received an associate degree' || data == 'Received a bachelor’s degree or higher' || data == 'Certificate')
        {
            this.showDegreeDate = true;
        }
        else{
            this.showDegreeDate = false;
        }
    }

    getMailStateList() {
        //this.profileForm.controls['mailState'].setValue('');
        this.stateApi.getStateList('US').subscribe((dataResponse) => {
            //console.log(dataResponse);
            this.mailStates = dataResponse;
        });
    }

    checkCinc(){
        const getDomainName = this.loginservice.getDomainName();
        const parts = window.location.hostname.split(getDomainName);
        //const countLength = parts.length;
        const subdomain = parts.shift();
        //console.log(subdomain);
        if(subdomain == 'cinc'){
            this.isCNIC = true;
            //this.oneducationLevelChange('Received an associate degree');
        }
        else
        {
            this.isCNIC = false;
            //this.oneducationLevelChange('Received an associate degree');
        }
    }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/prior-higher-education/prior-higher-education.component.ts